<template>
    <Resize id="app" class="app-layout" ref="app">
        <menu-app :menuClass="menuClass"></menu-app>
        <div class="content" id="content">
            <transition name="fade">
                <router-view :supportsWEBP="supportsWEBP" :bg="getCurrentBg" ref="page" @changeMenuClass="changeMenuClass"></router-view>
            </transition>
        </div>
        <a href="#" class="to-top" v-if="$root.isMobile" @click.prevent="toTop">
            <to-top></to-top>
        </a>
    </Resize>
</template>

<script>
    import Resize from '@/components/common/Resize';
    import Menu from '@/components/common/Menu';
    import icons from '@/assets/svg/icons';

    import {TweenLite} from 'gsap'
    import {mapGetters} from  'vuex'

    export default {
        name: 'app',
        data() {
          return {
              supportsWEBP: 'png',
              menuClass: null
          }
        },
        components: {
            'menu-app': Menu,
            Resize,
            'to-top': icons.arrowNext
        },
        computed: {
            ...mapGetters(['getCurrentBg'])
        },
        methods: {
            toTop() {
                this.$refs.page.$el.scrollTo(0,0);
            },
            changeMenuClass(data) {
                this.menuClass = (data) ? 'fix' : '';
            }
        },
        created() {
            (async () => {
                this.supportsWEBP = (await this.$root.Helpers.supportsWEBP())? 'webp' : 'png';
            })();
        },
        watch: {
            '$route': {
                immediate: true,
                    handler (to, from) {
                    if (to.name == 'Index') (!this.$root.isMobile) ? this.$store.commit('updateCurrentBg', '/static/img/pages/main/main_bg.jpg') : this.$store.commit('updateCurrentBg', '/static/img/pages/main/main_bg_mobile.jpg')
                }
            }
         }
    };
</script>



// WEBPACK FOOTER //
// App.vue?2961a476